import { render, staticRenderFns } from "./SubModalityTable.vue?vue&type=template&id=4a44dd44"
import script from "./SubModalityTable.vue?vue&type=script&lang=js"
export * from "./SubModalityTable.vue?vue&type=script&lang=js"
import style0 from "./SubModalityTable.vue?vue&type=style&index=0&id=4a44dd44&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports